import { BDCPFilterComponent } from './components/filter/filter.component';
import { BDCPFilterDeviceCategoryComponent } from './components/filter-device-category/filter-device-category.component';
import { BDCPFilterService } from './services/filter.service';
import { BDCPSharedModule } from '../shared/shared.module';
import { BDSharedModule } from '@brother-apps/brother-dealerapp-shared-lib';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BDCPSharedModule,
        BDSharedModule
    ],
    declarations: [
        BDCPFilterComponent,
        BDCPFilterDeviceCategoryComponent
    ],
    exports: [
        BDCPFilterComponent,
        BDCPFilterDeviceCategoryComponent
    ],
    providers: [
        BDCPFilterService
    ],
})
export class BDCPFilterModule { }
